import React, { useState } from 'react';
import { LazyPicture } from '@catalogo/theme-lazy-picture';
import styled from 'styled-components';
import { Icon } from './Icon';

export const Video = ({ image, alt }) => {
  const [showVideo, setShowVideo] = useState(false);

  if (showVideo) {
    return (
      <VideoWrapper>
        <Player src={image.video} width="100%" height="100%" allowFullScreen />
      </VideoWrapper>
    );
  }

  return (
    <Container>
      <IconUI fill="#999999" onClick={eventSetShowVideo(setShowVideo)} />
      <LazyPicture
        sources={{
          mobile: {
            src: image.main,
            ratio: '1:1',
          },
        }}
        lazy={false}
        alt={alt}
      />
    </Container>
  );
};

export const eventSetShowVideo = setShowVideo => () => setShowVideo(true);

const VideoWrapper = styled.div`
  position: relative;
  padding-bottom: 100%;
`;

const Player = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
`;

const IconUI = styled(Icon)`
  position: absolute;
  width: 40%;
  height: 40%;
  z-index: 1;
`;

export default Video;
